import script from "./CaseDetectAnonymization.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetectAnonymization.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetectAnonymization.vue?vue&type=style&index=0&id=1c6828ec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6828ec"]])

export default __exports__